/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as RegionRouteImport } from './routes/region'
import { Route as HandoverRouteImport } from './routes/handover'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PluginIndexRouteImport } from './routes/plugin/index'
import { Route as Oauth2CallbackRouteImport } from './routes/oauth2/callback'
import { Route as AuthenticatedSignOutRouteImport } from './routes/_authenticated/sign-out'
import { Route as AuthenticatedPendingApprovalRouteImport } from './routes/_authenticated/pending-approval'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as PluginFramerRouteRouteImport } from './routes/plugin/framer/route'
import { Route as PluginFigmaRouteRouteImport } from './routes/plugin/figma/route'
import { Route as PluginFramerIndexRouteImport } from './routes/plugin/framer/index'
import { Route as PluginFigmaIndexRouteImport } from './routes/plugin/figma/index'
import { Route as PluginFigmaSignUpRouteImport } from './routes/plugin/figma/sign-up'
import { Route as PluginFigmaSignInRouteImport } from './routes/plugin/figma/sign-in'
import { Route as PluginFigmaRegionRouteImport } from './routes/plugin/figma/region'
import { Route as PluginFigmaIntroRouteImport } from './routes/plugin/figma/intro'
import { Route as AuthenticatedSitesSiteIdRouteImport } from './routes/_authenticated/sites.$siteId'
import { Route as PluginFigmaOnboardingRouteRouteImport } from './routes/plugin/figma/onboarding/route'
import { Route as PluginFigmaOnboarding4RouteImport } from './routes/plugin/figma/onboarding/4'
import { Route as PluginFigmaOnboarding3RouteImport } from './routes/plugin/figma/onboarding/3'
import { Route as PluginFigmaOnboarding2RouteImport } from './routes/plugin/figma/onboarding/2'
import { Route as PluginFigmaOnboarding1RouteImport } from './routes/plugin/figma/onboarding/1'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const RegionRoute = RegionRouteImport.update({
  id: '/region',
  path: '/region',
  getParentRoute: () => rootRouteImport,
} as any)
const HandoverRoute = HandoverRouteImport.update({
  id: '/handover',
  path: '/handover',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PluginIndexRoute = PluginIndexRouteImport.update({
  id: '/plugin/',
  path: '/plugin/',
  getParentRoute: () => rootRouteImport,
} as any)
const Oauth2CallbackRoute = Oauth2CallbackRouteImport.update({
  id: '/oauth2/callback',
  path: '/oauth2/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSignOutRoute = AuthenticatedSignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPendingApprovalRoute =
  AuthenticatedPendingApprovalRouteImport.update({
    id: '/pending-approval',
    path: '/pending-approval',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const PluginFramerRouteRoute = PluginFramerRouteRouteImport.update({
  id: '/plugin/framer',
  path: '/plugin/framer',
  getParentRoute: () => rootRouteImport,
} as any)
const PluginFigmaRouteRoute = PluginFigmaRouteRouteImport.update({
  id: '/plugin/figma',
  path: '/plugin/figma',
  getParentRoute: () => rootRouteImport,
} as any)
const PluginFramerIndexRoute = PluginFramerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PluginFramerRouteRoute,
} as any)
const PluginFigmaIndexRoute = PluginFigmaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PluginFigmaRouteRoute,
} as any)
const PluginFigmaSignUpRoute = PluginFigmaSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => PluginFigmaRouteRoute,
} as any)
const PluginFigmaSignInRoute = PluginFigmaSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PluginFigmaRouteRoute,
} as any)
const PluginFigmaRegionRoute = PluginFigmaRegionRouteImport.update({
  id: '/region',
  path: '/region',
  getParentRoute: () => PluginFigmaRouteRoute,
} as any)
const PluginFigmaIntroRoute = PluginFigmaIntroRouteImport.update({
  id: '/intro',
  path: '/intro',
  getParentRoute: () => PluginFigmaRouteRoute,
} as any)
const AuthenticatedSitesSiteIdRoute =
  AuthenticatedSitesSiteIdRouteImport.update({
    id: '/sites/$siteId',
    path: '/sites/$siteId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const PluginFigmaOnboardingRouteRoute =
  PluginFigmaOnboardingRouteRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => PluginFigmaRouteRoute,
  } as any)
const PluginFigmaOnboarding4Route = PluginFigmaOnboarding4RouteImport.update({
  id: '/4',
  path: '/4',
  getParentRoute: () => PluginFigmaOnboardingRouteRoute,
} as any)
const PluginFigmaOnboarding3Route = PluginFigmaOnboarding3RouteImport.update({
  id: '/3',
  path: '/3',
  getParentRoute: () => PluginFigmaOnboardingRouteRoute,
} as any)
const PluginFigmaOnboarding2Route = PluginFigmaOnboarding2RouteImport.update({
  id: '/2',
  path: '/2',
  getParentRoute: () => PluginFigmaOnboardingRouteRoute,
} as any)
const PluginFigmaOnboarding1Route = PluginFigmaOnboarding1RouteImport.update({
  id: '/1',
  path: '/1',
  getParentRoute: () => PluginFigmaOnboardingRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/handover': typeof HandoverRoute
  '/region': typeof RegionRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/status': typeof StatusRoute
  '/verify-email': typeof VerifyEmailRoute
  '/plugin/figma': typeof PluginFigmaRouteRouteWithChildren
  '/plugin/framer': typeof PluginFramerRouteRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/pending-approval': typeof AuthenticatedPendingApprovalRoute
  '/sign-out': typeof AuthenticatedSignOutRoute
  '/oauth2/callback': typeof Oauth2CallbackRoute
  '/plugin/': typeof PluginIndexRoute
  '/plugin/figma/onboarding': typeof PluginFigmaOnboardingRouteRouteWithChildren
  '/sites/$siteId': typeof AuthenticatedSitesSiteIdRoute
  '/plugin/figma/intro': typeof PluginFigmaIntroRoute
  '/plugin/figma/region': typeof PluginFigmaRegionRoute
  '/plugin/figma/sign-in': typeof PluginFigmaSignInRoute
  '/plugin/figma/sign-up': typeof PluginFigmaSignUpRoute
  '/plugin/figma/': typeof PluginFigmaIndexRoute
  '/plugin/framer/': typeof PluginFramerIndexRoute
  '/plugin/figma/onboarding/1': typeof PluginFigmaOnboarding1Route
  '/plugin/figma/onboarding/2': typeof PluginFigmaOnboarding2Route
  '/plugin/figma/onboarding/3': typeof PluginFigmaOnboarding3Route
  '/plugin/figma/onboarding/4': typeof PluginFigmaOnboarding4Route
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/handover': typeof HandoverRoute
  '/region': typeof RegionRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/status': typeof StatusRoute
  '/verify-email': typeof VerifyEmailRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/pending-approval': typeof AuthenticatedPendingApprovalRoute
  '/sign-out': typeof AuthenticatedSignOutRoute
  '/oauth2/callback': typeof Oauth2CallbackRoute
  '/plugin': typeof PluginIndexRoute
  '/plugin/figma/onboarding': typeof PluginFigmaOnboardingRouteRouteWithChildren
  '/sites/$siteId': typeof AuthenticatedSitesSiteIdRoute
  '/plugin/figma/intro': typeof PluginFigmaIntroRoute
  '/plugin/figma/region': typeof PluginFigmaRegionRoute
  '/plugin/figma/sign-in': typeof PluginFigmaSignInRoute
  '/plugin/figma/sign-up': typeof PluginFigmaSignUpRoute
  '/plugin/figma': typeof PluginFigmaIndexRoute
  '/plugin/framer': typeof PluginFramerIndexRoute
  '/plugin/figma/onboarding/1': typeof PluginFigmaOnboarding1Route
  '/plugin/figma/onboarding/2': typeof PluginFigmaOnboarding2Route
  '/plugin/figma/onboarding/3': typeof PluginFigmaOnboarding3Route
  '/plugin/figma/onboarding/4': typeof PluginFigmaOnboarding4Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/handover': typeof HandoverRoute
  '/region': typeof RegionRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/status': typeof StatusRoute
  '/verify-email': typeof VerifyEmailRoute
  '/plugin/figma': typeof PluginFigmaRouteRouteWithChildren
  '/plugin/framer': typeof PluginFramerRouteRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/pending-approval': typeof AuthenticatedPendingApprovalRoute
  '/_authenticated/sign-out': typeof AuthenticatedSignOutRoute
  '/oauth2/callback': typeof Oauth2CallbackRoute
  '/plugin/': typeof PluginIndexRoute
  '/plugin/figma/onboarding': typeof PluginFigmaOnboardingRouteRouteWithChildren
  '/_authenticated/sites/$siteId': typeof AuthenticatedSitesSiteIdRoute
  '/plugin/figma/intro': typeof PluginFigmaIntroRoute
  '/plugin/figma/region': typeof PluginFigmaRegionRoute
  '/plugin/figma/sign-in': typeof PluginFigmaSignInRoute
  '/plugin/figma/sign-up': typeof PluginFigmaSignUpRoute
  '/plugin/figma/': typeof PluginFigmaIndexRoute
  '/plugin/framer/': typeof PluginFramerIndexRoute
  '/plugin/figma/onboarding/1': typeof PluginFigmaOnboarding1Route
  '/plugin/figma/onboarding/2': typeof PluginFigmaOnboarding2Route
  '/plugin/figma/onboarding/3': typeof PluginFigmaOnboarding3Route
  '/plugin/figma/onboarding/4': typeof PluginFigmaOnboarding4Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/handover'
    | '/region'
    | '/sign-in'
    | '/sign-up'
    | '/status'
    | '/verify-email'
    | '/plugin/figma'
    | '/plugin/framer'
    | '/dashboard'
    | '/pending-approval'
    | '/sign-out'
    | '/oauth2/callback'
    | '/plugin/'
    | '/plugin/figma/onboarding'
    | '/sites/$siteId'
    | '/plugin/figma/intro'
    | '/plugin/figma/region'
    | '/plugin/figma/sign-in'
    | '/plugin/figma/sign-up'
    | '/plugin/figma/'
    | '/plugin/framer/'
    | '/plugin/figma/onboarding/1'
    | '/plugin/figma/onboarding/2'
    | '/plugin/figma/onboarding/3'
    | '/plugin/figma/onboarding/4'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/handover'
    | '/region'
    | '/sign-in'
    | '/sign-up'
    | '/status'
    | '/verify-email'
    | '/dashboard'
    | '/pending-approval'
    | '/sign-out'
    | '/oauth2/callback'
    | '/plugin'
    | '/plugin/figma/onboarding'
    | '/sites/$siteId'
    | '/plugin/figma/intro'
    | '/plugin/figma/region'
    | '/plugin/figma/sign-in'
    | '/plugin/figma/sign-up'
    | '/plugin/figma'
    | '/plugin/framer'
    | '/plugin/figma/onboarding/1'
    | '/plugin/figma/onboarding/2'
    | '/plugin/figma/onboarding/3'
    | '/plugin/figma/onboarding/4'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/handover'
    | '/region'
    | '/sign-in'
    | '/sign-up'
    | '/status'
    | '/verify-email'
    | '/plugin/figma'
    | '/plugin/framer'
    | '/_authenticated/dashboard'
    | '/_authenticated/pending-approval'
    | '/_authenticated/sign-out'
    | '/oauth2/callback'
    | '/plugin/'
    | '/plugin/figma/onboarding'
    | '/_authenticated/sites/$siteId'
    | '/plugin/figma/intro'
    | '/plugin/figma/region'
    | '/plugin/figma/sign-in'
    | '/plugin/figma/sign-up'
    | '/plugin/figma/'
    | '/plugin/framer/'
    | '/plugin/figma/onboarding/1'
    | '/plugin/figma/onboarding/2'
    | '/plugin/figma/onboarding/3'
    | '/plugin/figma/onboarding/4'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  HandoverRoute: typeof HandoverRoute
  RegionRoute: typeof RegionRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
  StatusRoute: typeof StatusRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  PluginFigmaRouteRoute: typeof PluginFigmaRouteRouteWithChildren
  PluginFramerRouteRoute: typeof PluginFramerRouteRouteWithChildren
  Oauth2CallbackRoute: typeof Oauth2CallbackRoute
  PluginIndexRoute: typeof PluginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/region': {
      id: '/region'
      path: '/region'
      fullPath: '/region'
      preLoaderRoute: typeof RegionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/handover': {
      id: '/handover'
      path: '/handover'
      fullPath: '/handover'
      preLoaderRoute: typeof HandoverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plugin/': {
      id: '/plugin/'
      path: '/plugin'
      fullPath: '/plugin/'
      preLoaderRoute: typeof PluginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth2/callback': {
      id: '/oauth2/callback'
      path: '/oauth2/callback'
      fullPath: '/oauth2/callback'
      preLoaderRoute: typeof Oauth2CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/sign-out': {
      id: '/_authenticated/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof AuthenticatedSignOutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pending-approval': {
      id: '/_authenticated/pending-approval'
      path: '/pending-approval'
      fullPath: '/pending-approval'
      preLoaderRoute: typeof AuthenticatedPendingApprovalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/plugin/framer': {
      id: '/plugin/framer'
      path: '/plugin/framer'
      fullPath: '/plugin/framer'
      preLoaderRoute: typeof PluginFramerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plugin/figma': {
      id: '/plugin/figma'
      path: '/plugin/figma'
      fullPath: '/plugin/figma'
      preLoaderRoute: typeof PluginFigmaRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plugin/framer/': {
      id: '/plugin/framer/'
      path: '/'
      fullPath: '/plugin/framer/'
      preLoaderRoute: typeof PluginFramerIndexRouteImport
      parentRoute: typeof PluginFramerRouteRoute
    }
    '/plugin/figma/': {
      id: '/plugin/figma/'
      path: '/'
      fullPath: '/plugin/figma/'
      preLoaderRoute: typeof PluginFigmaIndexRouteImport
      parentRoute: typeof PluginFigmaRouteRoute
    }
    '/plugin/figma/sign-up': {
      id: '/plugin/figma/sign-up'
      path: '/sign-up'
      fullPath: '/plugin/figma/sign-up'
      preLoaderRoute: typeof PluginFigmaSignUpRouteImport
      parentRoute: typeof PluginFigmaRouteRoute
    }
    '/plugin/figma/sign-in': {
      id: '/plugin/figma/sign-in'
      path: '/sign-in'
      fullPath: '/plugin/figma/sign-in'
      preLoaderRoute: typeof PluginFigmaSignInRouteImport
      parentRoute: typeof PluginFigmaRouteRoute
    }
    '/plugin/figma/region': {
      id: '/plugin/figma/region'
      path: '/region'
      fullPath: '/plugin/figma/region'
      preLoaderRoute: typeof PluginFigmaRegionRouteImport
      parentRoute: typeof PluginFigmaRouteRoute
    }
    '/plugin/figma/intro': {
      id: '/plugin/figma/intro'
      path: '/intro'
      fullPath: '/plugin/figma/intro'
      preLoaderRoute: typeof PluginFigmaIntroRouteImport
      parentRoute: typeof PluginFigmaRouteRoute
    }
    '/_authenticated/sites/$siteId': {
      id: '/_authenticated/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof AuthenticatedSitesSiteIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/plugin/figma/onboarding': {
      id: '/plugin/figma/onboarding'
      path: '/onboarding'
      fullPath: '/plugin/figma/onboarding'
      preLoaderRoute: typeof PluginFigmaOnboardingRouteRouteImport
      parentRoute: typeof PluginFigmaRouteRoute
    }
    '/plugin/figma/onboarding/4': {
      id: '/plugin/figma/onboarding/4'
      path: '/4'
      fullPath: '/plugin/figma/onboarding/4'
      preLoaderRoute: typeof PluginFigmaOnboarding4RouteImport
      parentRoute: typeof PluginFigmaOnboardingRouteRoute
    }
    '/plugin/figma/onboarding/3': {
      id: '/plugin/figma/onboarding/3'
      path: '/3'
      fullPath: '/plugin/figma/onboarding/3'
      preLoaderRoute: typeof PluginFigmaOnboarding3RouteImport
      parentRoute: typeof PluginFigmaOnboardingRouteRoute
    }
    '/plugin/figma/onboarding/2': {
      id: '/plugin/figma/onboarding/2'
      path: '/2'
      fullPath: '/plugin/figma/onboarding/2'
      preLoaderRoute: typeof PluginFigmaOnboarding2RouteImport
      parentRoute: typeof PluginFigmaOnboardingRouteRoute
    }
    '/plugin/figma/onboarding/1': {
      id: '/plugin/figma/onboarding/1'
      path: '/1'
      fullPath: '/plugin/figma/onboarding/1'
      preLoaderRoute: typeof PluginFigmaOnboarding1RouteImport
      parentRoute: typeof PluginFigmaOnboardingRouteRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedPendingApprovalRoute: typeof AuthenticatedPendingApprovalRoute
  AuthenticatedSignOutRoute: typeof AuthenticatedSignOutRoute
  AuthenticatedSitesSiteIdRoute: typeof AuthenticatedSitesSiteIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedPendingApprovalRoute: AuthenticatedPendingApprovalRoute,
  AuthenticatedSignOutRoute: AuthenticatedSignOutRoute,
  AuthenticatedSitesSiteIdRoute: AuthenticatedSitesSiteIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PluginFigmaOnboardingRouteRouteChildren {
  PluginFigmaOnboarding1Route: typeof PluginFigmaOnboarding1Route
  PluginFigmaOnboarding2Route: typeof PluginFigmaOnboarding2Route
  PluginFigmaOnboarding3Route: typeof PluginFigmaOnboarding3Route
  PluginFigmaOnboarding4Route: typeof PluginFigmaOnboarding4Route
}

const PluginFigmaOnboardingRouteRouteChildren: PluginFigmaOnboardingRouteRouteChildren =
  {
    PluginFigmaOnboarding1Route: PluginFigmaOnboarding1Route,
    PluginFigmaOnboarding2Route: PluginFigmaOnboarding2Route,
    PluginFigmaOnboarding3Route: PluginFigmaOnboarding3Route,
    PluginFigmaOnboarding4Route: PluginFigmaOnboarding4Route,
  }

const PluginFigmaOnboardingRouteRouteWithChildren =
  PluginFigmaOnboardingRouteRoute._addFileChildren(
    PluginFigmaOnboardingRouteRouteChildren,
  )

interface PluginFigmaRouteRouteChildren {
  PluginFigmaOnboardingRouteRoute: typeof PluginFigmaOnboardingRouteRouteWithChildren
  PluginFigmaIntroRoute: typeof PluginFigmaIntroRoute
  PluginFigmaRegionRoute: typeof PluginFigmaRegionRoute
  PluginFigmaSignInRoute: typeof PluginFigmaSignInRoute
  PluginFigmaSignUpRoute: typeof PluginFigmaSignUpRoute
  PluginFigmaIndexRoute: typeof PluginFigmaIndexRoute
}

const PluginFigmaRouteRouteChildren: PluginFigmaRouteRouteChildren = {
  PluginFigmaOnboardingRouteRoute: PluginFigmaOnboardingRouteRouteWithChildren,
  PluginFigmaIntroRoute: PluginFigmaIntroRoute,
  PluginFigmaRegionRoute: PluginFigmaRegionRoute,
  PluginFigmaSignInRoute: PluginFigmaSignInRoute,
  PluginFigmaSignUpRoute: PluginFigmaSignUpRoute,
  PluginFigmaIndexRoute: PluginFigmaIndexRoute,
}

const PluginFigmaRouteRouteWithChildren =
  PluginFigmaRouteRoute._addFileChildren(PluginFigmaRouteRouteChildren)

interface PluginFramerRouteRouteChildren {
  PluginFramerIndexRoute: typeof PluginFramerIndexRoute
}

const PluginFramerRouteRouteChildren: PluginFramerRouteRouteChildren = {
  PluginFramerIndexRoute: PluginFramerIndexRoute,
}

const PluginFramerRouteRouteWithChildren =
  PluginFramerRouteRoute._addFileChildren(PluginFramerRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  HandoverRoute: HandoverRoute,
  RegionRoute: RegionRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
  StatusRoute: StatusRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  PluginFigmaRouteRoute: PluginFigmaRouteRouteWithChildren,
  PluginFramerRouteRoute: PluginFramerRouteRouteWithChildren,
  Oauth2CallbackRoute: Oauth2CallbackRoute,
  PluginIndexRoute: PluginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
